import { FluentIconsProps, wrapIcon } from '@fluentui/react-icons';

export const PrivacyIcon = wrapIcon(
    (props: FluentIconsProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <path
                d="M10 2L16.25 4.5V9.16667C16.25 13.1746 13.3333 16.5 10 18C6.66667 16.5 3.75 13.1746 3.75 9.16667V4.5L10 2Z"
                stroke="#4D5562"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M8 9.5C8 8.67157 8.67157 8 9.5 8H10.5C11.3284 8 12 8.67157 12 9.5V11C12 11.8284 11.3284 12.5 10.5 12.5H9.5C8.67157 12.5 8 11.8284 8 11V9.5Z"
                stroke="#4D5562"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M9.5 10.5H10.5"
                stroke="#4D5562"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'PrivacyIcon'
);